import { useId } from 'react';
import { Label, Select } from '@/shared/components';
import type { TemplateOwner } from '../types/documentTemplates.types';
import { OWNER_FILTER_OPTIONS } from '../utils/templateListOptions';
import { DealerOwnerSelect } from './DealerOwnerSelect';

interface Props {
  owner: TemplateOwner | undefined;
  dealerId: string | undefined;
  onOwnerChange: (owner: TemplateOwner | undefined) => void;
  onDealerChange: (dealerId: string | undefined) => void;
}

export function TemplateOwnerFilter({ owner, dealerId, onOwnerChange, onDealerChange }: Props) {
  const ownerLabelId = useId();
  const dealerInputId = useId();

  return (
    <>
      <div>
        <Label id={ownerLabelId}>Owner</Label>
        <Select
          options={OWNER_FILTER_OPTIONS}
          ariaLabelledBy={ownerLabelId}
          value={owner ?? ''}
          onChange={(value) => {
            const next = value === '' ? undefined : (value as TemplateOwner);
            onOwnerChange(next);
            if (next === 'platform') onDealerChange(undefined);
          }}
        />
      </div>
      {owner !== 'platform' && (
        <div>
          <Label htmlFor={dealerInputId}>Dealer</Label>
          <DealerOwnerSelect
            id={dealerInputId}
            value={dealerId ?? null}
            onChange={(id) => onDealerChange(id ?? undefined)}
            placeholder="Any dealer"
          />
        </div>
      )}
    </>
  );
}
